// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"b5e83904","921":"b3aed8d3"}[chunkId] + ".chunk.js";
};